//#region frontend/islands/social-video-player.js
var SocialVideoPlayer = class extends HTMLElement {
	connectedCallback() {
		this.video = this.querySelector("video");
		this.playButton = this.querySelector("[data-play-button]");
		this.playIcon = this.querySelector("[data-icon-play]");
		this.pauseIcon = this.querySelector("[data-icon-pause]");
		this.onPlayButtonClick = this.handlePlayButtonClick.bind(this);
		this.onVideoPlay = this.handleVideoPlay.bind(this);
		this.onVideoPause = this.handleVideoPause.bind(this);
		this.onVideoEnded = this.handleVideoEnded.bind(this);
		this.onSiblingPlay = this.handleSiblingPlay.bind(this);
		this.swiperContainer = this.closest("swiper-container");
		this.swiperContainer?.addEventListener("social-video-play", this.onSiblingPlay);
		this.playButton?.addEventListener("click", this.onPlayButtonClick);
		this.video?.addEventListener("play", this.onVideoPlay);
		this.video?.addEventListener("pause", this.onVideoPause);
		this.video?.addEventListener("ended", this.onVideoEnded);
		this.loadObserver = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				this.video.preload = "metadata";
				this.loadObserver.disconnect();
			}
		}, { rootMargin: "300px 0px" });
		this.loadObserver.observe(this);
		this.visibilityObserver = new IntersectionObserver(([entry]) => {
			if (!this.video) return;
			if (!entry.isIntersecting) {
				this.video.pause();
				this.video.currentTime = 0;
			}
		}, { threshold: .5 });
		this.visibilityObserver.observe(this);
		this.slide = this.closest("swiper-slide");
		if (this.slide && this.swiperContainer) {
			this.slideVisbilityObserver = new IntersectionObserver(([entry]) => {
				entry.target.classList.toggle("opacity-0", !entry.isIntersecting);
			}, {
				root: this.swiperContainer,
				threshold: 0
			});
			this.slideVisbilityObserver.observe(this.slide);
		}
		const posterImg = this.video?.querySelector("img");
		if (posterImg) posterImg.alt = "";
	}
	disconnectedCallback() {
		this.playButton?.removeEventListener("click", this.onPlayButtonClick);
		this.video?.removeEventListener("play", this.onVideoPlay);
		this.video?.removeEventListener("pause", this.onVideoPause);
		this.video?.removeEventListener("ended", this.onVideoEnded);
		this.swiperContainer?.removeEventListener("social-video-play", this.onSiblingPlay);
		this.loadObserver?.disconnect();
		this.visibilityObserver?.disconnect();
		this.slideVisbilityObserver?.disconnect();
	}
	handlePlayButtonClick() {
		if (!this.video) return;
		if (this.video.paused || this.video.ended) this.video.play();
		else this.video.pause();
	}
	handleSiblingPlay(event) {
		if (event.detail.player !== this && this.video && !this.video.paused) this.video.pause();
	}
	handleVideoPlay() {
		this.swiperContainer?.dispatchEvent(new CustomEvent("social-video-play", { detail: { player: this } }));
		this.dataset.playing = "true";
		this.playIcon?.style.setProperty("opacity", "0%");
		this.pauseIcon?.style.setProperty("opacity", "100%");
		if (this.playButton) this.playButton.setAttribute("aria-label", "Pause video");
	}
	handleVideoPause() {
		this.dataset.playing = "false";
		this.playIcon?.style.setProperty("opacity", "100%");
		this.pauseIcon?.style.setProperty("opacity", "0%");
		if (this.playButton) this.playButton.setAttribute("aria-label", "Play video");
	}
	handleVideoEnded() {
		this.handleVideoPause();
	}
};
window.customElements.define("social-video-player", SocialVideoPlayer);
//#endregion
